// @ts-strict-ignore
import React, { memo, useState } from 'react'

import { SpecialCondition } from '@/screens/Product/page/types/types'

import { TCartItem, useCart } from '@/entities/cart'
import { NotificationCard } from '@/entities/Payments'
import { CardModal } from '@/entities/Payments/ui/CardModal/CardModal'

import { CatalogItemLocation, LocalProduct, ProductType, TAddProductRequest } from '@/shared/types/deprecated-types'

import cls from './condition-list.module.scss'

interface ConditionListProps {
	items: SpecialCondition[]
	productId: number
	relatedProducts?: (TCartItem | LocalProduct)[]
}

const getActiveInstallmentText = (cardTitle: string) => `Вам доступна рассрочка ${cardTitle}`

const isActiveCondition = (condition: SpecialCondition, relatedProducts: (TCartItem | LocalProduct)[]) =>
	!!relatedProducts.find(({ ID }) => condition.productList.some(({ PRODUCT_ID }) => ID === PRODUCT_ID))

export const ConditionList = memo((props: ConditionListProps) => {
	const [activeCondition, setActiveCondition] = useState<SpecialCondition>()
	const [isModalOpen, setIsModalOpen] = useState(false)
	const { addItem } = useCart()
	const { items, productId, relatedProducts } = props

	const onOpen = (condition: SpecialCondition) => {
		setActiveCondition(condition)
		setIsModalOpen(true)
	}
	const onClose = () => setIsModalOpen(false)

	const addServiceCard = (id: number, condition: SpecialCondition) => {
		const selectedService = condition.productList.find(({ PRODUCT_ID }) => PRODUCT_ID === id)
		const payload: TAddProductRequest = {
			ID: id,
			RELATED_PRODUCTS: productId,
			TYPE_PRODUCTS: ProductType.Service,
			PRICE: { VALUE: selectedService.PRICE },
			TITLE: selectedService.NAME,
			updateBasket: true,
			location: CatalogItemLocation.ServicesCart
		}
		addItem(payload)
		onClose()
	}

	return (
		<>
			<div className={cls.conditionList}>
				{items.map(item => {
					const isActive = isActiveCondition(item, relatedProducts)
					const description = isActive ? getActiveInstallmentText(item.installmentCode) : item.description

					return (
						<NotificationCard
							description={description}
							withArrowPrefix={!isActive}
							disabled={isActive}
							key={item.description}
							onClick={!isActive ? () => onOpen(item) : null}
						/>
					)
				})}
			</div>
			{activeCondition && (
				<CardModal
					items={activeCondition.productList}
					onApply={id => addServiceCard(id, activeCondition)}
					onClose={onClose}
					isOpen={isModalOpen}
				/>
			)}
		</>
	)
})
